export default class BaseModel {
}
